export interface UndoableCommand {
	label: string;
	execute(): void;
	undo(): void;
}

type Listener = () => void;

export class UndoStack {
	private _done: UndoableCommand[] = [];
	private _undone: UndoableCommand[] = [];
	private _maxSize: number;
	private _listeners = new Set<Listener>();

	constructor(maxSize = 50) {
		this._maxSize = maxSize;
	}

	get canUndo(): boolean {
		return this._done.length > 0;
	}

	get canRedo(): boolean {
		return this._undone.length > 0;
	}

	push(cmd: UndoableCommand): void {
		cmd.execute();
		this._done.push(cmd);
		this._undone.length = 0;
		if (this._done.length > this._maxSize) {
			this._done.shift();
		}
		this._notify();
	}

	undo(): void {
		const cmd = this._done.pop();
		if (!cmd) return;
		cmd.undo();
		this._undone.push(cmd);
		this._notify();
	}

	redo(): void {
		const cmd = this._undone.pop();
		if (!cmd) return;
		cmd.execute();
		this._done.push(cmd);
		this._notify();
	}

	clear(): void {
		this._done.length = 0;
		this._undone.length = 0;
		this._notify();
	}

	onChange(listener: Listener): () => void {
		this._listeners.add(listener);
		return () => this._listeners.delete(listener);
	}

	private _notify(): void {
		for (const l of this._listeners) l();
	}
}
